import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Empty } from '@/components/ui/Empty';
import { ActionPlansColumns } from '../Form/ActionPlansColumns';
import { ReportSelectionPanel } from '../Form/ReportSelectionPanel';
import { SelectedReportsInfo } from '../components/SelectedReportsInfo';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { Header } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Header';
import { useGetDataExtractionSelectedReportsCount } from '@/hooks/useGetDataExtractionSelectedReportsCount';
import { StepsContainer } from '../../../styles';

const { useFormInstance, useWatch } = Form;

export function ActionPlansSection(): JSX.Element {
	const form = useFormInstance();
	const { dataExtractionReport } = useDataExtractionReport();
	const selectedReports = useWatch(['action_plans', 'selected_reports'], form) || [];

	const { data: selectedCount } = useGetDataExtractionSelectedReportsCount({
		organization_id: dataExtractionReport?.organization_id || '',
		data_extraction_id: dataExtractionReport?.id
	});

	const hasReportSelected = !!dataExtractionReport?.custom_report_id;
	const hasActionPlanExtraction = Boolean(dataExtractionReport?.has_action_plan_extraction);
	const selectedReportsCount = selectedCount?.count || 0;
	const hasAnyReportSelected = hasReportSelected || selectedReports.length > 0 || selectedReportsCount > 0;

	return (
		<StepsContainer>
			<Row gutter={[0, 32]} justify="space-between">
				<Col>
					<Header
						title={I18n.get('Planos de ação')}
						description={I18n.get('Source and information of action plans')}
					/>
				</Col>
				{!hasReportSelected && (
					<>
						<Col span={24}>
							<ReportSelectionPanel />
						</Col>
						<Col span={24}>
							<ActionPlansColumns disabled={!hasAnyReportSelected} />
						</Col>
					</>
				)}
				{hasReportSelected && !hasActionPlanExtraction && (
					<Col span={24} style={{ textAlign: 'center', marginTop: '2rem' }}>
						<Empty message={I18n.get('No action plan is linked to this extraction')} />
					</Col>
				)}
				{hasReportSelected && hasActionPlanExtraction && (
					<>
						<Col span={24}>
							<SelectedReportsInfo
								evaluationsCount={selectedReportsCount}
								selectedReportType={dataExtractionReport?.custom_report?.name || ''}
							/>
						</Col>
						<Col span={24}>
							<ActionPlansColumns disabled={!hasAnyReportSelected} />
						</Col>
					</>
				)}
			</Row>
		</StepsContainer>
	);
}
